import {
  Component,
  OnInit,
  Input,
  HostListener,
  HostBinding,
  TemplateRef,
  OnDestroy,
  ChangeDetectionStrategy,
  ElementRef,
  Renderer2,
  ChangeDetectorRef,
  ViewChild,
  AfterContentInit
} from '@angular/core';
import { formatDate } from '@angular/common';
import { HttpEvent, HttpEventType, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { ControlValueAccessor } from '@angular/forms';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';
import { UploadXHRArgs, UploadFile, NzModalService, UploadChangeParam } from 'ng-zorro-antd';
import { ClipboardService } from 'ngx-clipboard';
import { TextMaskConfig } from 'angular2-text-mask';
import {
  NgxExcelComponentState,
  NgxExcelCellMode,
  NgxExcelColumnType,
  NgxExcelColumn,
  NgxExcelColumnTemplateContext,
  NgxExcelSelectOption,
  NgxExcelCellEvent,
  NgxExcelUploadFile
} from '../../models/models';
import { NgxExcelUploadService } from '../../services/services';
import { NgxExcelCellInterface } from '../../interfaces/ngx-excel-cell.interface';
import createNumberInputMask from '../../input-mask-addons/createNumberInputMask';
import createCurrencyInputMask from '../../input-mask-addons/createCurrencyInputMask';
import createDateTimeInputMask from '../../input-mask-addons/createDateTimeInputMask';
import { NgxExcelContextComponent } from '../ngx-excel-context/ngx-excel-context.component';
import { Subscription, Subject, Observable, of, throwError, Observer, noop } from 'rxjs';
import { mergeMap, delay, debounceTime, switchMap, filter, map, catchError } from 'rxjs/operators';
import { utc } from 'moment';
import * as lodash from 'lodash';

@Component({
  selector: 'ngx-excel-cell[normalCell]',
  templateUrl: './ngx-excel-cell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NgxExcelCellComponent extends NgxExcelCellInterface implements OnInit, OnDestroy, AfterContentInit, ControlValueAccessor {

  componentValue: any;
  componentContext = null;
  componentValueStr: string;
  invalidFeedback = '';
  componentModeEnums = NgxExcelCellMode;
  componentMode: NgxExcelCellMode = this.componentModeEnums.ReadMode;
  componentStateEnums = NgxExcelComponentState;
  componentState: NgxExcelComponentState = this.componentStateEnums.Normal;
  // cellModes: typeof NgxExcelCellMode = NgxExcelCellMode;
  // columnTypes: typeof NgxExcelColumnType = NgxExcelColumnType;
  columnTypeEnums = NgxExcelColumnType;
  // componentStates: typeof NgxExcelComponentState = NgxExcelComponentState;

  multilineTextCopied = false;
  multilineTextAcceptedWordCount = 0;

  selectIsLoading = false;
  selectAllowClear = false;
  selectAllowMultiple = false;
  selectTypeaheadKey = '';
  selectSearchSubject = new Subject<string>();
  selectOptions: any[] = [];
  // selectFilters: (currentContext: any, keyword?: string) => Observable<any[]> = null;
  selectOptionLabelKey = 'label';
  selectAcceptedCount = 0;
  selectCompareWith: (o1: any, o2: any) => boolean;

  uploadUrl = './';
  uploadAcceptedFileIcons = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'];
  uploadButtonOptions = { showPreviewIcon: true, showRemoveIcon: true };
  uploadMaxCount = 3;
  uploadAcceptedFileType = '*.*';
  uploadCustomRequest: (item: UploadXHRArgs) => Subscription;
  // uploadActionUrl: string;
  // uploadActionName: string;
  // uploadActionParams: (file: any) => any;
  uploadFileChange: (uploadChangeParam: UploadChangeParam) => void;
  // uploadResolveFile: (file: UploadFile) => NgxExcelUploadFile;
  uploadBeforeCallback: (file: File) => Observable<boolean>;
  uploadPreviewCallback: (file: UploadFile) => void;
  uploadRemoveCallback: (file: UploadFile) => Observable<boolean>;
  uploadPreviewUrl: string;

  /*selectForeignContextTypeahead = false;
  selectForeignContextLoading = false;
  selectForeignContextTypeaheadInput$: Subject<string>;
  selectForeignContext$: Observable<any>;
  selectForeignContexts: any[] = [];*/

  inputMaskTextNumber: TextMaskConfig;
  inputMaskNumber: TextMaskConfig;
  inputMaskCurrency: TextMaskConfig;
  inputMaskNegativeCurrency: TextMaskConfig;
  inputMaskDate: TextMaskConfig;
  inputMaskTime: TextMaskConfig;
  inputMaskDateTime: TextMaskConfig;

  private _readonly = false;
  // private _disabled = false;
  // private _originalComponentContext = null;
  private _doubleClickedCount = 0;
  private _doubleClickedTn = null;
  private _contextMenuComponent: ContextMenuComponent;
  // protected onSelectedCallback: (component: NgxExcelCellComponent, column: NgxExcelColumn, context: any) => void;
  private _onChangeCallback: (column: NgxExcelColumn, value: any) => Observable<any>;
  private _onTouchCallback: (component: NgxExcelCellComponent, column: NgxExcelColumn) => void;
  private _onTouchedCallback: (component: NgxExcelCellComponent, column: NgxExcelColumn | string, value: any) => void;
  private _canEditFn: (column: NgxExcelColumn) => boolean;
  private _validateFn: (column: NgxExcelColumn, value: any) => boolean | string | Observable<boolean | string>;
  private _uploadServiceFactory: (payload: { [name: string]: string | Blob }) => NgxExcelUploadService;
  private _pullForeignModelsFn: (column: NgxExcelColumn, keyword?: string) => Observable<any[]>;
  private _pullSelectOptionsFn: (column: NgxExcelColumn) => Observable<NgxExcelSelectOption[]>;

  private _componentSubscription = new Subscription();

  @Input() excelContext: NgxExcelContextComponent;
  @Input() template: TemplateRef<NgxExcelColumnTemplateContext>;
  @Input() templateEdit: TemplateRef<NgxExcelColumnTemplateContext>;
  @Input() templateOptional: TemplateRef<NgxExcelColumnTemplateContext>;
  @Input() onClickedCallback: (context: any) => void;
  @Input() placeholder: string;
  @Input()
  set disabled(value: boolean) {
    this._readonly = value === false ? false : true;
    if (this._readonly) {
      this.uploadButtonOptions.showRemoveIcon = false;
    }
  }
  get disabled(): boolean { return this._readonly; }

  // @Output() selectCell = new EventEmitter<NgxExcelCellSelectedEvent>();
  // @Output() doubleClickCell = new EventEmitter<NgxExcelCellDoubleClickedEvent>();
  @ViewChild('uploadPreviewModalTpl', { read: TemplateRef, static: false }) uploadPreviewModalTpl: TemplateRef<any>;
  @HostBinding('class.ngx-excel-cell--normal') excelCellClass = true;
  @HostBinding('class.ngx-excel-cell--normal-upload') excelCellUploadClass = false;
  @HostBinding('class.ngx-excel-cell--normal-multiline-text') excelCellMultilineTextClass = false;
  @HostBinding('class.selected') selectedClass = false;
  @HostBinding('class.disabled') disabledClass = false;
  @HostListener('click', ['$event']) onExcelCellClicked(e: Event) {
    if (this.column.columnType !== NgxExcelColumnType.UploadFile && this.column.columnType !== NgxExcelColumnType.MultiUploadFile) {
      // ä¸ä¼ æä»¶éè¦ç©¿éäºä»¶
      e.stopPropagation();
      e.preventDefault();
    }
    if (this._contextMenuComponent) {
      this.contextMenuService.closeAllContextMenus(null);
    }
    if (!this.componentContext || this.componentState === NgxExcelComponentState.Loading) { return; }
    // if (!this._excelRow.context || this.componentState === NgxExcelComponentState.Loading) { return; }
    if (this.onClickedCallback) {
      this._doubleClickedCount = 0;
      this.onClickedCallback(this.componentContext);
    }

    if (this.selectedClass && this._doubleClickedCount > 0) {
      this._switchEditMode();
    } else {
      // åå» éä¸­
      if (this._readonly) {
        this.disabledClass = true;
      } else {
        this.disabledClass = !this._canEditFn || !this._canEditFn(this.column);
      }

      this.componentState = NgxExcelComponentState.Normal;
      this.invalidFeedback = '';
      this._doubleClickedCount += 1;
      clearTimeout(this._doubleClickedTn);
      this._doubleClickedTn = setTimeout(() => this._doubleClickedCount = 0, 2000);
      if (this.selectedClass) { return; }
      this.selectedClass = true;
      if (this._onTouchCallback) {
        this._onTouchCallback(this, this.column);
      }
    }
  }

  @HostListener('contextmenu', ['$event']) onContextMenu(e: MouseEvent) {
    clearTimeout(this._doubleClickedTn);
    this._doubleClickedCount = 0;
    if (!this.selectedClass) {
      this.selectedClass = true;
      if (this._onTouchCallback) {
        this._onTouchCallback(this, this.column);
      }
    }
    if (!this._contextMenuComponent) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    this.contextMenuService.show.next({
      contextMenu: this._contextMenuComponent,
      event: e,
      item: { context: this.componentContext, column: this.column } as NgxExcelCellEvent
    });
    e.preventDefault();
    e.stopPropagation();
  }

  constructor(
    protected el: ElementRef,
    protected renderer2: Renderer2,
    protected cdr: ChangeDetectorRef,
    protected modalService: NzModalService,
    protected contextMenuService: ContextMenuService,
    protected clipboardService: ClipboardService
  ) {
    super(el, renderer2, cdr, contextMenuService);
  }

  ngOnInit() {
    this.inputMaskTextNumber = createNumberInputMask({ preZero: true });
    this.inputMaskNumber = createNumberInputMask();
    this.inputMaskCurrency = createCurrencyInputMask();
    this.inputMaskNegativeCurrency = createCurrencyInputMask({ negative: true });
    this.inputMaskDate = createDateTimeInputMask('YYYY-MM-DD', { min: '1900-01-01' });
    this.inputMaskTime = createDateTimeInputMask('HH:mm');
    this.inputMaskDateTime = createDateTimeInputMask('YYYY-MM-DD HH:mm');
    this.disabledClass = this.disabled;

    if (this.column.columnType === NgxExcelColumnType.UploadFile || this.column.columnType === NgxExcelColumnType.MultiUploadFile) {
      this._initialUploadCell();
    } else if (this.column.columnType === NgxExcelColumnType.MultilineText) {
      this._initialMultilineTextCell();
    } else if (
      this.column.columnType === NgxExcelColumnType.SelectOption ||
      this.column.columnType === NgxExcelColumnType.MultiSelectOption ||
      this.column.columnType === NgxExcelColumnType.TagsSelectOption ||
      this.column.columnType === NgxExcelColumnType.ForeignKey ||
      this.column.columnType === NgxExcelColumnType.MultiForeignKey
    ) {
      this._initialSelectCell();
    }
  }

  ngOnDestroy() {
    this._componentSubscription.unsubscribe();
  }

  ngAfterContentInit() {
    if (!this.excelContext) { return; }
    this.excelContext.initialCellComponent(this);
  }

  /**
   * ç»ä»¶èµå¼
   * @param context æ°æ®è¡
   */
  writeValue(context: any, once?: boolean) {
    this.componentContext = context;
    if (
      this.column.columnType === NgxExcelColumnType.UploadFile ||
      this.column.columnType === NgxExcelColumnType.MultiUploadFile
    ) {
      once ? this._rebuildComponentValue() : noop();
    } else {
      this._rebuildComponentValue();
    }
  }

  /**
   * æ³¨åååæ ¼çå¼åååè°äºä»¶
   * @param callback åè°å½æ°
   */
  registerOnChange(callback: (column: NgxExcelColumn, value: any) => Observable<any>) {
    this._onChangeCallback = callback;
  }

  /**
   * æ³¨åååæ ¼çè·å¾ç¦ç¹åè°äºä»¶
   * @param callback åè°å½æ°
   */
  registerOnTouch(callback: (component: NgxExcelCellComponent, column: NgxExcelColumn) => void) {
    this._onTouchCallback = callback;
  }

  /**
   * æ³¨åååæ ¼çå¤±å»ç¦ç¹åè°äºä»¶
   * @param callback åè°å½æ°
   */
  registerOnTouched(callback: (component: NgxExcelCellComponent, column: NgxExcelColumn | string, value: any) => void) {
    this._onTouchedCallback = callback;
  }

  /**
   * æ³¨åæä»¶ä¸ä¼ æå¡çå·¥åå½æ°
   * @param factory å·¥åå½æ°
   */
  registerUploadServiceFactory(factory: (payload: { [name: string]: string | Blob }) => NgxExcelUploadService) {
    this._uploadServiceFactory = factory;
  }

  /**
   * æ³¨åå¤æ­ååæ ¼æ¯å¦å¯è¢«ç¼è¾çå½æ°
   * @param fn å¤æ­å½æ°
   */
  registerCanEditFn(fn: (column: NgxExcelColumn) => boolean) {
    this._canEditFn = fn;
  }

  /**
   * æ³¨åå¤æ­ååæ ¼æææ§çå½æ°
   * @param fn å¤æ­å½æ°
   */
  registerValidateFn(fn: (column: NgxExcelColumn, value: any) => boolean | string | Observable<boolean | string>) {
    this._validateFn = fn;
  }

  /**
   * æåå¤é®æ¨¡åçå½æ°
   * @param fn å¤é¨å½æ°
   */
  registerPullForeignModelsFn(fn: (column: NgxExcelColumn, keyword?: string) => Observable<any[]>) {
    this._pullForeignModelsFn = fn;
  }

  /**
   * æåä¸æèåçå½æ°
   * @param fn å¤é¨å½æ°
   */
  registerPullSelectOptionsFn(fn: (column: NgxExcelColumn) => Observable<NgxExcelSelectOption[]>) {
    this._pullSelectOptionsFn = fn;
  }

  /**
   * è®¾ç½®ç»ä»¶çå¯ç¨æ§
   * @param isDisabled æ¯å¦ç¦ç¨
   */
  setDisabledState(isDisabled: boolean) {

  }

  templateHandle = (e: Event, value: any) => {
    this.componentMode = NgxExcelCellMode.ReadMode;
    if (!this._onChangeCallback) { return; }
    this._onChangeCallback(this.column, value);
  }

  /**
   * ä¸æèåå¯éé¡¹æç´¢
   * @param keyword æç´¢å³é®å­
   */
  onSelectSearch(keyword: string) {
    this.selectIsLoading = true;
    if (
      this.columnTypeEnums.MultiForeignKey === this.column.columnType ||
      this.columnTypeEnums.MultiSelectOption === this.column.columnType ||
      this.columnTypeEnums.TagsSelectOption === this.column.columnType
    ) {
      this.selectOptions = [...this.componentValue];
    } else if (this.componentValue) {
      this.selectOptions = [this.componentValue];
    }
    this.selectSearchSubject.next(keyword || '');
  }

  /**
   * å½ pencil å¾æ è¢«ç¹å»æ¶æ§è¡
   * @param e ç¹å»äºä»¶
   */
  handleEditClicked(e: Event) {
    e.stopPropagation();
    e.preventDefault();
    this._switchEditMode();
  }

  handleCopyButtonClick(e: Event) {
    e.stopPropagation();
    e.preventDefault();
    this.clipboardService.copyFromContent(this.componentValue);
    this.multilineTextCopied = true;
    this.cdr.detectChanges();
  }

  /**
   * å½ç»ä»¶å¼ç¡®è®¤æ¶æ§è¡
   */
  handleComponentValueChanged() {
    const originalComponentValue = lodash.get(this.componentContext, this.column.name, null);
    // if ((!this.componentValue && !originalComponentValue) || (this.componentValue === originalComponentValue)) { return; }
    // console.log(componentValue, this.componentValue, originalComponentValue);
    // å½æ¥ææ¶é´æ§ä»¶ç´æ¥ç¹ç¡®è®¤æ¶èªå¨èµå¼ä¸ºå½åæ¥æ
    if (this.column.columnType === this.columnTypeEnums.DateTime && this.componentValue === null) {
      this.componentValue = new Date();
    }
    if (this.componentValue === originalComponentValue) { return; }

    // let isValid = true;
    switch (this.column.columnType) {
      case this.columnTypeEnums.Date:
      case this.columnTypeEnums.Time:
      case this.columnTypeEnums.DateTime:
        try {
          const formatter = this.column.columnType === this.columnTypeEnums.Date ? 'yyyy-MM-dd' : (
            this.column.columnType === this.columnTypeEnums.Time ? 'HH:mm' : 'yyyy-MM-dd HH:mm'
          );
          const componentValue = formatDate(this.componentValue, formatter, 'zh');
          if (originalComponentValue === componentValue) { return; }
          this.componentValue = componentValue;
        } catch (_) {
          this.componentValue = null;
        }
        break;
      case this.columnTypeEnums.DateTimeRange:
      case this.columnTypeEnums.DateRange:
        const rangeFormatter = this.column.columnType === this.columnTypeEnums.DateTimeRange ? 'yyyy-MM-dd HH:mm' : 'yyyy-MM-dd';
        let stringBegin = '';
        let stringEnd = '';
        try { stringBegin = formatDate(this.componentValue[0], rangeFormatter, 'zh'); } catch (_) { }
        try { stringEnd = formatDate(this.componentValue[1], rangeFormatter, 'zh'); } catch (_) { }
        const rangeComponentValue = stringBegin.length === 0 && stringEnd.length === 0 ? '' : `${stringBegin},${stringEnd}`;
        if (originalComponentValue === rangeComponentValue) { return; }
        this.componentValue = rangeComponentValue;
        break;
      case this.columnTypeEnums.TextNumber:
      case this.columnTypeEnums.Number:
        // tslint:disable-next-line: triple-equals
        if (this.componentValue == originalComponentValue) { return; }
        break;
      case this.columnTypeEnums.SelectOption:
      case this.columnTypeEnums.ForeignKey:
        if (!this.selectCompareWith || this.selectCompareWith(this.componentValue, originalComponentValue)) { return; }
        break;
      case this.columnTypeEnums.MultiSelectOption:
      case this.columnTypeEnums.TagsSelectOption:
      case this.columnTypeEnums.MultiForeignKey:
        if (!this.selectCompareWith) { return; }
        const selectOptions = lodash.intersectionWith(
          this.componentValue as NgxExcelSelectOption[],
          originalComponentValue as NgxExcelSelectOption[],
          this.selectCompareWith
        );
        if (
          this.componentValue.length === originalComponentValue.length &&
          this.componentValue.length === selectOptions.length
        ) { return; }
        break;
      default:
        break;
    }
    this.multilineTextCopied = false;
    this.componentMode = this.componentModeEnums.ReadMode;
    this.componentState = this.componentStateEnums.Loading;

    let validStream = this._validateFn ? this._validateFn(this.column, this.componentValue) : of(true);
    if (!(validStream instanceof Observable)) {
      validStream = of(validStream).pipe(delay(200));
    }
    validStream.pipe(
      mergeMap((validResult) => {
        if (typeof (validResult) === 'string') {
          return throwError(new Error(validResult));
        }
        return this._onChangeCallback ? this._onChangeCallback(this.column, this.componentValue) : of(this.componentValue);
      })
    ).subscribe(() => {
      this.componentState = this.componentStateEnums.Normal;
      this._rebuildComponentValue();
    }, (e) => {
      this.componentState = this.componentStateEnums.Warning;
      this.invalidFeedback = e.message || 'æ°æ®æäº¤éè¯¯';
      this._rebuildComponentValue();
    });
  }

  public reload() { }

  /**
   * æ³¨åååæ ¼ä¸ä¸æèå
   * @param contextMenuComponent ä¸ä¸æèåç»ä»¶
   */
  public registerContextMenu(contextMenuComponent: ContextMenuComponent) {
    this._contextMenuComponent = contextMenuComponent;
  }

  /**
   * å¤é¨è°ç¨ååæ ¼è¢«éä¸­
   */
  public select() {
    if (this.selectedClass) { return; }
    clearTimeout(this._doubleClickedTn);
    this._doubleClickedCount = 0;
    this.selectedClass = true;
    if (this._onTouchCallback) {
      this._onTouchCallback(this, this.column);
    }
    this.cdr.markForCheck();
  }

  /**
   * å¤é¨è°ç¨ååæ ¼åæ¶éä¸­
   */
  public unselect() {
    if (!this.selectedClass) { return; }
    clearTimeout(this._doubleClickedTn);
    this._doubleClickedCount = 0;
    this.selectedClass = false;
    // å¤±å»ç¦ç¹æ¶ç¼è¾ç¶æåä¸ºè¯»æ¨¡å¼
    this.componentMode = NgxExcelCellMode.ReadMode;
    if (this._onTouchedCallback) {
      this._onTouchedCallback(this, this.column, this.componentValue);
    }
    // this.handleComponentValueChanged();
    this.cdr.markForCheck();
  }

  /**
   * éå»ºç»ä»¶å³èçå±æ§å¼
   * @param componentValue æ°çå±æ§å¼
   */
  private _rebuildComponentValue(componentValue?: any) {
    const value = componentValue === undefined ? lodash.get(this.componentContext, this.column.name, null) : componentValue;
    switch (this.column.columnType) {
      case this.columnTypeEnums.Number:
        this.componentValue = (this.column.optional || value) ? `${value || 0}` : '';
        break;
      case this.columnTypeEnums.DateTime:
        const datetimeObj = utc(`${value}:00 +0800`, 'YYYY-MM-DD HH:mm:ss Z', true);
        this.componentValue = datetimeObj.isValid() ? datetimeObj.toDate() : null;
        break;
      case this.columnTypeEnums.Date:
        const dateObj = utc(`${value} +0800`, 'YYYY-MM-DD Z', true);
        this.componentValue = dateObj.isValid() ? dateObj.toDate() : '';
        break;
      case this.columnTypeEnums.Time:
        const timeObj = utc(`${value} +0800`, 'HH:mm Z', true);
        this.componentValue = timeObj.isValid() ? timeObj.toDate() : null;
        break;
      case this.columnTypeEnums.DateTimeRange:
      case this.columnTypeEnums.DateRange:
        const rangeValues = (value || '').split(',');
        if (rangeValues.length < 2) {
          this.componentValue = null;
          break;
        }
        const rangeFormatter = this.column.columnType === this.columnTypeEnums.DateTimeRange ?
          'YYYY-MM-DD HH:mm:ss Z' : 'YYYY-MM-DD Z';
        const rangePadding = this.column.columnType === this.columnTypeEnums.DateTimeRange ?
          ':00 +0800' : ' +0800';
        const beginObj = utc(`${rangeValues[0]}${rangePadding}`, rangeFormatter, true);
        rangeValues[0] = beginObj.isValid() ? beginObj.toDate() : null;
        const endObj = utc(`${rangeValues[1]}${rangePadding}`, rangeFormatter, true);
        rangeValues[1] = endObj.isValid() ? endObj.toDate() : null;
        this.componentValue = [...rangeValues];
        break;
      case this.columnTypeEnums.Bool:
        this.componentValue = this.column.optional && value === null ? null : !!value;
        break;
      case this.columnTypeEnums.SelectOption:
      case this.columnTypeEnums.ForeignKey:
        this.componentValue = value ? Object.assign({}, value) : null;
        break;
      case this.columnTypeEnums.MultiSelectOption:
      case this.columnTypeEnums.TagsSelectOption:
      case this.columnTypeEnums.MultiForeignKey:
        if (value && lodash.isArray(value)) {
          this.componentValue = value.map((o) => Object.assign({}, o));
        } else {
          this.componentValue = [];
        }
        break;
      case this.columnTypeEnums.UploadFile:
      case this.columnTypeEnums.MultiUploadFile:
        this.componentValue = (
          this.column.columnType === this.columnTypeEnums.UploadFile ?
            [value || null] :
            (lodash.isArray(value) ? value : [])
        ).filter(
          (uploadFile: NgxExcelUploadFile) => uploadFile && uploadFile.id && uploadFile.url
        ).map(
          (uploadFile: NgxExcelUploadFile) => {
            const file = {
              id: uploadFile.id,
              uid: uploadFile.id,
              size: 0,
              name: uploadFile.name || 'æªç¥åç§°',
              status: 'done',
              url: uploadFile.url,
              type: uploadFile.mimeType
            } as UploadFile;
            file.thumbUrl = this._getUploadService().getThumbUrl(uploadFile);
            /* if (!file.type.toLowerCase().startsWith('image/')) {
              file.thumbUrl = this._getUploadFileIcon(file.name);
            } */
            return file;
          }
        );
        break;
      default:
        this.componentValue = `${value || ''}`;
    }
    try { this.cdr.detectChanges(); } catch (_) { }
  }

  /**
   * æ ¹æ®å­æ®µåè·å¾å½åä¸ä¸æçå­æ®µå¼
   * @param componentValue è¡åå®¹å¯¹è±¡å±æ§å¼
   */
  /*private _getComponentValueStr(componentValue: any) {
    let componentValueStr = '';
    switch (this.column.columnType) {
      case NgxExcelColumnType.Number:
        componentValueStr = (this.column.optional || componentValue) ? `${componentValue}` : '';
        break;
      case NgxExcelColumnType.DateTime:
        const datetimeObj = utc(componentValue, 'YYYY-MM-DD HH:mm', true);
        componentValueStr = datetimeObj.isValid() ? datetimeObj.format('YYYY-MM-DD HH:mm') : '';
        break;
      case NgxExcelColumnType.Date:
        const dateObj = utc(componentValue, 'YYYY-MM-DD', true);
        componentValueStr = dateObj.isValid() ? dateObj.format('YYYY-MM-DD') : '';
        break;
      case NgxExcelColumnType.Time:
        const timeObj = utc(componentValue, 'HH:mm', true);
        componentValueStr = timeObj.isValid() ? timeObj.format('HH:mm') : '';
        break;
      case NgxExcelColumnType.SelectOption:
        componentValueStr = lodash.get(componentValue, 'label', '');
        break;
      case NgxExcelColumnType.Bool:
        componentValueStr = this.componentValue ? 'æ¯' : 'å¦';
        break;
      case NgxExcelColumnType.ForeignKey:
        // this.componentValue = lodash.get(context, this.column.name, null);
        componentValueStr = lodash.get(componentValue, this.column.labelKey, '');
        break;
      default:
        componentValueStr = `${this.componentValue}`;
    }
    return componentValueStr;
  }*/

  /**
   * åæ¢å°ç¼è¾æ¨¡å¼
   */
  private _switchEditMode() {
    if (!this.componentContext) { return; }

    clearTimeout(this._doubleClickedTn);
    this._doubleClickedCount = 0;

    // å½åååæ ¼å·²ç»æ¯ç¼è¾æ¨¡å¼æèååæ ¼æ¯åªè¯» / åªå / ç¦ç¨ç¶æåä¸å¯è½åæ¬¡è¿å¥ç¼è¾æ¨¡å¼
    if (this.componentMode === NgxExcelCellMode.EditMode || this._readonly) { return; }

    if (!this._canEditFn) { return; }
    if (!this._canEditFn(this.column)) {
      this.disabledClass = true;
      return;
    }

    // åå» è¿å¥ç¼è¾æ¨¡å¼
    if (
      this.column.columnType === NgxExcelColumnType.ForeignKey ||
      this.column.columnType === NgxExcelColumnType.MultiForeignKey
    ) {
      this.selectAcceptedCount = this.column.acceptedSelectedCount > 0 ? this.column.acceptedSelectedCount : Infinity;
      this.selectAllowMultiple = this.column.columnType === NgxExcelColumnType.MultiForeignKey;
      this.selectOptionLabelKey = this.column.labelKey;
      this.selectCompareWith = (o1: any, o2: any) => !!o1 && !!o2 && o1.id === o2.id;
      if (this.column.selectOptions && this.column.selectOptions.length > 0) {
        this.selectTypeaheadKey = '';
        this.selectOptions = this.column.selectOptions;
      } else {
        this.selectTypeaheadKey = this.column.typeaheadKey || '';
        this.onSelectSearch(this.column.typeaheadKey ? '' : null);
      }
    } else if (
      this.column.columnType === NgxExcelColumnType.SelectOption ||
      this.column.columnType === NgxExcelColumnType.MultiSelectOption ||
      this.column.columnType === NgxExcelColumnType.TagsSelectOption
    ) {
      this.selectAcceptedCount = this.column.acceptedSelectedCount > 0 ? this.column.acceptedSelectedCount : Infinity;
      // this.selectOptions = this.column.selectOptions || [];
      this.selectCompareWith = (o1: NgxExcelSelectOption, o2: NgxExcelSelectOption) => !!o1 && !!o2 && o1.value === o2.value;
      this.onSelectSearch(null);
    }

    this.componentMode = NgxExcelCellMode.EditMode;
  }

  /**
   * éæ©æ¡ååæ ¼åå§å
   */
  private _initialSelectCell() {
    const selectSearchSubscription = this.selectSearchSubject.asObservable().pipe(
      filter(() => {
        if (
          this.column.columnType === this.columnTypeEnums.ForeignKey ||
          this.column.columnType === this.columnTypeEnums.MultiForeignKey
        ) {
          return !!this._pullForeignModelsFn;
        } else {
          return !!this._pullSelectOptionsFn;
        }
      }),
      debounceTime(500),
      switchMap((keyword) => {
        if (
          this.column.columnType === this.columnTypeEnums.ForeignKey ||
          this.column.columnType === this.columnTypeEnums.MultiForeignKey
        ) {
          return this._pullForeignModelsFn(this.column, this.column.typeaheadKey ? keyword : null);
        } else {
          return this._pullSelectOptionsFn(this.column);
        }
      })
    ).subscribe((selectOptions) => {
      this.selectOptions = [...selectOptions];
      if (this.column.typeaheadKey && this.componentValue) {
        const originalComponentValue = (
          this.column.columnType === this.columnTypeEnums.MultiForeignKey ||
          this.column.columnType === this.columnTypeEnums.MultiSelectOption ||
          this.column.columnType === this.columnTypeEnums.TagsSelectOption
        ) ? [...this.componentValue] : [this.componentValue];
        originalComponentValue.forEach((original) => {
          let hit = false;
          if (this.selectCompareWith) {
            hit = this.selectOptions.some((selectOption) => this.selectCompareWith(selectOption, original));
          }
          if (!hit && original) {
            this.selectOptions.unshift(Object.assign({}, this.componentValue));
          }
        });
      }
      this.selectIsLoading = false;
      this.cdr.detectChanges();
    }, (e: any) => {
      console.warn(e);
      this.selectOptions = [];
      this.selectIsLoading = false;
      this.cdr.detectChanges();
    });
    this._componentSubscription.add(selectSearchSubscription);
  }

  /**
   * å¤è¡ææ¬åå§å
   */
  private _initialMultilineTextCell() {
    this.excelCellMultilineTextClass = true;
    this.multilineTextAcceptedWordCount = this.column.acceptedWordCount;
  }

  /**
   * ä¸ä¼ æä»¶ååæ ¼åå§å
   */
  private _initialUploadCell() {
    this.excelCellUploadClass = true;
    this.uploadMaxCount = this.column.columnType === this.columnTypeEnums.UploadFile ? 1 : (this.column.acceptedFileCount || 3);
    if (!this.column.acceptedFileType || this.column.acceptedFileType.length === 0) {
      this.uploadAcceptedFileType = '*.*';
    } else if (typeof (this.column.acceptedFileType) === 'string') {
      this.uploadAcceptedFileType = this.column.acceptedFileType;
    } else {
      this.uploadAcceptedFileType = this.column.acceptedFileType.join(',');
    }

    // const uploadConfig = this._getUploadService().getConfig();
    /* this.uploadActionUrl = uploadConfig.url;
    if (uploadConfig.name) {
      this.uploadActionName = uploadConfig.name;
    }
    if (uploadConfig.extraParams) {
      this.uploadActionParams = Object.assign({}, uploadConfig.extraParams);
    } */
    // this.uploadActionUrl = 'documents/_upload';
    /* this.uploadActionName = 'upload_files';
    const resolve = (response: any) => ({
      id: `${response['data']['id']}`,
      name: response['data']['file_name'],
      url: response['data']['file_url'],
      mimeType: response['data']['mime_type'],
      remark: ''
    }); */
    this.uploadFileChange = ({ file, fileList, type }) => {
      if (type !== 'error' && type !== 'success' && type !== 'removed') { return; }
      if (type === 'error') {
        this.componentState = this.componentStateEnums.Warning;
        if (file.error instanceof HttpErrorResponse) {
          this.invalidFeedback = file.error.error.message || 'æä»¶ä¸ä¼ éè¯¯';
        } else {
          this.invalidFeedback = 'æä»¶ä¸ä¼ éè¯¯';
        }
      }
      const uploadFiles = fileList
        .filter((uploadFile: UploadFile) => uploadFile.status === 'done')
        .map((uploadFile: UploadFile) => (uploadFile.response || {
          id: uploadFile.uid,
          name: uploadFile.name,
          mimeType: uploadFile.type,
          url: uploadFile.url
        }));

      let componentValue: any;
      if (this.column.columnType === NgxExcelColumnType.MultiUploadFile) {
        componentValue = [...uploadFiles];
      } else {
        componentValue = uploadFiles.length > 0 ? uploadFiles[0] : null;
      }
      lodash.set(this.componentContext, this.column.name, componentValue);
      (this._onChangeCallback ? this._onChangeCallback(this.column, componentValue) : of(componentValue)).subscribe(
        () => {
          this.componentState = this.componentStateEnums.Normal;
          this.invalidFeedback = '';
          this._rebuildComponentValue();
        }, (e) => console.warn(e)
      );
    };
    /* this.uploadActionParams = (file) => ({
      upload_files: file
    }); */

    // æä»¶ä¸ä¼ 
    this.uploadCustomRequest = (uploadXHRArgs: UploadXHRArgs) => this._getUploadService().upload(uploadXHRArgs).pipe(
      mergeMap((event: HttpEvent<{}>) => {
        if (event.type === HttpEventType.UploadProgress) {
          if (event.total > 0) {
            // tslint:disable-next-line:no-any
            (event as any).percent = (event.loaded / event.total) * 100;
          }
          uploadXHRArgs.onProgress(event, uploadXHRArgs.file);
        } else if (event instanceof HttpResponse) {
          const file = event.body as NgxExcelUploadFile;
          /* if (!uploadXHRArgs.file.type.toLowerCase().startsWith('image/')) {
            uploadXHRArgs.file.thumbUrl = this._getUploadFileIcon(uploadXHRArgs.file.name);
          } */
          uploadXHRArgs.file.thumbUrl = this._getUploadService().getThumbUrl(file);
          uploadXHRArgs.onSuccess(event.body, uploadXHRArgs.file, event);
          /* let componentValue: any;
          if (this.column.columnType === NgxExcelColumnType.MultiUploadFile) {
            componentValue = lodash.get(this.componentContext, this.column.name, []);
            componentValue.push(file);
          } else {
            componentValue = file;
          } */
          // lodash.set(this.componentContext, this.column.name, componentValue);
          // return this._onChangeCallback ? this._onChangeCallback(this.column, componentValue) : of(componentValue);
          return of(true);
        }
        return of(false);
      })
    ).subscribe(
      (_) => { },
      (e) => {
        /* console.log(e);
        if (!uploadXHRArgs.file.type.toLowerCase().startsWith('image/')) {
          uploadXHRArgs.file.thumbUrl = this._getUploadFileIcon(uploadXHRArgs.file.name);
        } */
        uploadXHRArgs.onError(e, uploadXHRArgs.file);
        this.componentState = this.componentStateEnums.Warning;
        if (e instanceof HttpErrorResponse) {
          this.invalidFeedback = e.error.message || 'æä»¶ä¸ä¼ éè¯¯';
        } else {
          this.invalidFeedback = 'æä»¶ä¸ä¼ éè¯¯';
        }
      }
    );

    // æä»¶å é¤
    this.uploadRemoveCallback = (file: UploadFile) => this._getUploadService().remove(file).pipe(
      map(() => true),
      catchError((e) => {
        this.componentState = this.componentStateEnums.Warning;
        this.invalidFeedback = e.message || 'å é¤æä»¶éè¯¯';
        return of(false);
      })
    );

    // ä¸ä¼ ä¹åéè¦éªè¯æä»¶ç±»ååæä»¶å¤§å°
    this.uploadBeforeCallback = (file: File) => new Observable((observer: Observer<boolean>) => {
      try {
        const fileTypeValidResult = this._validateFileType(file);
        if (typeof (fileTypeValidResult) === 'string') {
          throw new Error(fileTypeValidResult);
        }

        const fileSizeValidResult = this._validateFileSize(file);
        if (typeof (fileSizeValidResult) === 'string') {
          throw new Error(fileSizeValidResult);
        }
      } catch (e) {
        this.componentState = this.componentStateEnums.Warning;
        this.invalidFeedback = e.message || 'æ°æ®æäº¤éè¯¯';
        observer.complete();
        return;
      }

      // èªå®ä¹éªè¯è§å
      let validStream = this._validateFn ? this._validateFn(this.column, file) : of(true);
      if (!(validStream instanceof Observable)) {
        validStream = of(validStream).pipe(delay(200));
      }
      validStream.pipe(mergeMap((validResult) => {
        if (typeof (validResult) === 'string') {
          return throwError(new Error(validResult));
        }
        return of(validResult);
      })).subscribe(() => {
        this.componentState = this.componentStateEnums.Normal;
        this.invalidFeedback = '';
        observer.next(true);
        observer.complete();
      }, (e) => {
        this.componentState = this.componentStateEnums.Warning;
        this.invalidFeedback = e.message || 'æ°æ®æäº¤éè¯¯';
        observer.complete();
      });
    });

    // æä»¶é¢è§æä¸è½½
    this.uploadPreviewCallback = (file: UploadFile) => {
      if (file.status === 'error' || file.status === 'uploading') {
        // ä¸æåçæä»¶ä¸åè®¸é¢è§
        return;
      }
      if (file.type.toLowerCase().startsWith('image/')) {
        // å½æä»¶ä¸ºå¾çæ¶é¢è§å¾ç
        this.uploadPreviewUrl = this._getUploadService().getPreviewUrl(
          { name: file.name, mimeType: file.type, url: file.url } as NgxExcelUploadFile
        );
        // this.uploadPreviewUrl = file.url || file.thumbUrl;
        this.modalService.create({
          // nzTitle: 'é¢è§å¾ç',
          nzClassName: 'upload-preview-modal',
          nzContent: this.uploadPreviewModalTpl,
          nzFooter: null,
          nzClosable: true,
          nzMaskClosable: true
        }).afterClose.subscribe(() => this.uploadPreviewUrl = '');
      } else {
        // å½æä»¶ä¸ºéå¾çæ¶ç´æ¥ä¸è½½æä»¶
        const downloadUrl = this._getUploadService().getDownloadUrl(
          { name: file.name, mimeType: file.type, url: file.url } as NgxExcelUploadFile
        );
        window.open(downloadUrl);
      }
    };

    /* this.uploadRemoveCallback = (file: UploadFile) => {
      return of(file).pipe(
        mergeMap((uploadedFile) => {
          if (!uploadedFile) {
            return throwError(new Error('å é¤æªç¥çæä»¶'));
          }

          let componentValue: any;
          if (this.column.columnType === NgxExcelColumnType.MultiUploadFile) {
            componentValue = lodash.get(this.componentContext, this.column.name, [])
              .filter((uploadFile: NgxExcelUploadFile) => uploadFile.id !== uploadedFile.uid);
          } else {
            const originalComponentValue = lodash.get(this.componentContext, this.column.name, null) as NgxExcelUploadFile;
            if (!originalComponentValue || originalComponentValue.id === uploadedFile.uid) {
              componentValue = null;
            } else {
              componentValue = originalComponentValue;
            }
          }
          lodash.set(this.componentContext, this.column.name, componentValue);
          return this._onChangeCallback ? this._onChangeCallback(this.column, componentValue) : of(componentValue);
        }),
        map(() => true),
        catchError((e) => {
          this.componentState = this.componentStateEnums.Warning;
          this.invalidFeedback = e.message || 'å é¤æä»¶éè¯¯';
          return of(false);
        })
      );
    }; */
  }

  /**
   * è·å¾ä¸ä¼ æå¡å¯¹è±¡
   */
  private _getUploadService(): NgxExcelUploadService {
    return this._uploadServiceFactory({});
  }

  /**
   * è·å¾æä»¶ç±»åå¾æ 
   * @param filename æä»¶å
   */
  /* private _getUploadFileIcon(filename: string): string {
    const pos = filename.lastIndexOf('.');
    const extension = pos > 0 ? filename.substr(pos).toLowerCase() : '';
    return this.uploadAcceptedFileIcons.indexOf(extension) >= 0 ?
      `/assets/icons/${extension}.png` : '';
  } */

  /**
   * éªè¯ä¸ä¼ æä»¶çç±»å
   * @param file ä¸ä¼ çæä»¶
   */
  private _validateFileType(file: File): boolean | string {
    const acceptedFileExtensions: string[] = [];
    const acceptedFileMimeTypes: string[] = [];
    (
      this.column.acceptedFileType && typeof (this.column.acceptedFileType) === 'string' ?
        this.column.acceptedFileType.split(',') : (this.column.acceptedFileType as string[])
    ).forEach((acceptedFileType) => {
      if (acceptedFileType.startsWith('.')) {
        acceptedFileExtensions.push(acceptedFileType.toLowerCase());
      } else if (acceptedFileType.indexOf('/') > 0) {
        const mimeTypeParts = acceptedFileType.split('/').filter((mimeTypePart) => mimeTypePart.length > 0);
        const i = mimeTypeParts.findIndex((mimeTypePart) => mimeTypePart === '*');
        if (i === -1) {
          acceptedFileMimeTypes.push(mimeTypeParts.join('/').toLowerCase());
        } else {
          acceptedFileMimeTypes.push(mimeTypeParts.slice(0, i).join('/').toLowerCase());
        }
      }
    });

    if (acceptedFileExtensions.length === 0 && acceptedFileMimeTypes.length === 0) {
      // ä¸éæä»¶ç±»å
      return true;
    }

    if (acceptedFileExtensions.length > 0) {
      const isValid = acceptedFileExtensions.some(
        (acceptedFileExtension) => file.name.toLowerCase().endsWith(acceptedFileExtension)
      );
      // æä»¶æ»¡è¶³æ©å±åéå¶
      if (isValid) { return true; }
    }

    if (acceptedFileMimeTypes.length > 0) {
      const isValid = acceptedFileMimeTypes.some(
        (acceptedFileMimeType) => file.type.toLowerCase().startsWith(acceptedFileMimeType)
      );
      // æä»¶æ»¡è¶³ MimeType éå¶
      if (isValid) { return true; }
    }

    let message = 'åªè½ä¸ä¼ çæä»¶ç±»åï¼';
    if (acceptedFileExtensions.length > 0 && acceptedFileMimeTypes.length > 0) {
      message += acceptedFileExtensions.join(',') + ',' + acceptedFileMimeTypes.join(',');
    } else {
      message += acceptedFileExtensions.length > 0 ? acceptedFileExtensions.join(',') : acceptedFileMimeTypes.join(',');
    }
    return message;
  }

  /**
   * éªè¯ä¸ä¼ æä»¶çå¤§å°
   * @param file ä¸ä¼ çæä»¶
   */
  private _validateFileSize(file: File): boolean | string {
    let acceptedFileSize = 0; // Unit: B
    if (typeof (this.column.acceptedFileSize) === 'string') {
      if (this.column.acceptedFileSize.toUpperCase().endsWith('MB')) {
        acceptedFileSize = parseFloat(this.column.acceptedFileSize) * 1024 * 1024;
      } else if (this.column.acceptedFileSize.toUpperCase().endsWith('KB')) {
        acceptedFileSize = parseFloat(this.column.acceptedFileSize) * 1024;
      } else {
        acceptedFileSize = parseFloat(this.column.acceptedFileSize);
      }
    } else {
      acceptedFileSize = (this.column.acceptedFileSize || 0) * 1024;
    }

    if (acceptedFileSize === 0) {
      // ä¸éå¶æä»¶å¤§å°
      return true;
    }

    if (acceptedFileSize >= file.size) {
      // æä»¶æ»¡è¶³å¤§å°éå¶
      return true;
    }

    let message = 'åªè½ä¸ä¼ çæä»¶å¤§å°ï¼';
    if (typeof (this.column.acceptedFileSize) === 'string') {
      message += this.column.acceptedFileSize;
    } else {
      message += this.column.acceptedFileSize + ' KB';
    }
    return message;
  }

}
